<template>
  <div>
    <div class="banner"><img src="../../static/images/bj.png" /></div>
    <div class="content">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="150px"
        class="demo-ruleForm"
        style="margin-top: 20px"
      >
        <el-form-item label="供应公司" prop="supplyCompany">
          <!-- <el-input v-model="ruleForm.supplyCompany"></el-input> -->

          <el-select
            v-model="ruleForm.supplyCompany"
            filterable
            default-first-option
            allow-create
            placeholder="请输入公司名称"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="药品 (通用名)" prop="commonName">
          <el-input v-model="ruleForm.commonName" placeholder="请输入药品通用名"></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="contactPerson">
          <el-input v-model="ruleForm.contactPerson" placeholder="请输入联系人"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="contactPhone">
          <el-input v-model="ruleForm.contactPhone" placeholder="请输入联系电话"></el-input>
        </el-form-item>
      </el-form>
      <div class="tips">注：请确认已通过药学部初审，否则提交无效~</div>
      <div class="butncontent">
        <div class="button1 button" @click="check()">查看审核结果</div>
        <div class="button" @click="submit()">提交</div>
      </div>
    </div>
  </div>
</template>

<script>
import { applyCompany, checkCompany, dictItem } from "@/request/api";
var validatorPhone = function (rule, value, callback) {
  if (value === "") {
    callback(new Error("手机号不能为空"));
  } else if (!/^1\d{10}$/.test(value)) {
    callback(new Error("手机号格式错误"));
  } else {
    callback();
  }
};
export default {
  name: "HelloWorld",
  data() {
    return {
      ruleForm: {
        supplyCompany: "",
        contactPerson: "",
        contactPhone: "",
      },
      rules: {
        supplyCompany: [
          { required: true, message: "请输入供应公司", trigger: "blur" },
        ],
        contactPerson: [
          { required: true, message: "请输入联系人", trigger: "blur" },
        ],
        contactPhone: [
          { required: true, validator: validatorPhone, trigger: "blur" },
        ],
        commonName: [
          { required: true, message: "请输入药品通用名", trigger: "blur" },
        ],
      },
      options: [],
      value2: "",
    };
  },
  created() {
    this.getdicitem();
  },
  methods: {
    handleClick(tab, event) {
      console.log(this.activeName);
      this.getlist(this.activeName);
    },
    getdicitem() {
      dictItem({ dictCode: "dict_company", pageNumber: 1, pageSize: 50 }).then(
        (res) => {
          let data = res.data.data.list;
          this.options = [];
          data.forEach((element) => {
            this.options.push({
              value: element.itemValue,
              label: element.itemText,
            });
          });
        }
      );
    },
    submit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$confirm("确定向研究机构发起新药引进申请吗？")
            .then((_) => {
              applyCompany(this.ruleForm)
                .then((res) => {
                  checkCompany(this.ruleForm).then((res) => {
                    console.log("222");
                    console.log(res.data.data);
                    if (res.data.data.logicStatus == 4) {
                      this.$router.push({
                        path: "/content",
                        query: {
                          id: res.data.data.id,
                          contactPhone: this.ruleForm.contactPhone,
                          contactPerson: this.ruleForm.contactPerson,
                          supplyCompany: this.ruleForm.supplyCompany,
                          commonName: this.ruleForm.commonName,
                        },
                      });
                    } else {
                      this.$router.push({
                        path: "/waring",
                        query: {
                          contactPhone: this.ruleForm.contactPhone,
                          contactPerson: this.ruleForm.contactPerson,
                          supplyCompany: this.ruleForm.supplyCompany,
                          commonName: this.ruleForm.commonName,
                        },
                      });
                    }
                  });
                })
                .catch(function (error) {
                  // 请求失败处理
                  this.$message.error("error submit!");
                });
            })
            .catch((_) => {});
        } else {
          return false;
        }
      });
    },
    check() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          checkCompany(this.ruleForm).then((res) => {
            if (res.data.data.logicStatus == null) {
              this.$message("该公司没有提交申请");
            } else {
              this.$router.push({
                path: "/waring2",
                query: {
                  contactPhone: this.ruleForm.contactPhone,
                  contactPerson: this.ruleForm.contactPerson,
                  supplyCompany: this.ruleForm.supplyCompany,
                  commonName: this.ruleForm.commonName,
                },
              });
            }
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style>
.content {
  padding: 20px 20px;
}

.banner img {
  width: 100%;
}

.butncontent {
  display: flex;
}

.butncontent .button {
  width: 40%;
}

.button1 {
  background: #fff;
  color: #01c190;
}

.tips {
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #e60000;
  text-align: center;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/view/home.vue